import { CUBE_AGGREGATE_INTERACTION } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { CubeQuery, GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfig } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';
import { EVENT_NAME_FILTER_LIMIT } from '../../filterDefaultLimits';

const EVENT_NAME_OPTIONS: GetOptionsQueryFunction = ({ sourceCube, dateRange }) => {
  const timeDimensions = getDateRangeTimeDimension({
    dateRange,
    dimension: `${CUBE_AGGREGATE_INTERACTION}.interaction_date`,
  });
  const query: CubeQuery = {
    dimensions: [`${sourceCube}.event_name`],
    limit: EVENT_NAME_FILTER_LIMIT,
    filters: [
      { member: `${sourceCube}.is_invitation`, operator: 'equals', values: ['1'] },
      { member: `${sourceCube}.hcp_bk`, operator: 'set' },
    ],
    timeDimensions: [timeDimensions],
  };
  return query;
};

const eventNameFilter: FilterConfig = {
  searchable: true,
  label: 'global.filters.formControls.eventNameLabel',
  placeholder: 'global.filters.formControls.eventNamePlaceholder',
  type: 'multiselect',
  clearable: true,
  getOptionsQuery: EVENT_NAME_OPTIONS,
  sourceCube: CUBE_AGGREGATE_INTERACTION,
  mapResult: mapDimensionToOption(`${CUBE_AGGREGATE_INTERACTION}.event_name`),
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${CUBE_AGGREGATE_INTERACTION}.event_name`,
      operator: 'equals',
      values: [...v],
    };
  },
  defaultValue: [],
};

export default eventNameFilter;
